/**
 * 메시지 코드 기반 다국어 처리를 위한 메시지 맵
 */

// 한국어 메시지 (기본)
const koMessages = {
  ACCOUNT_LOCKED: (params) => `계정이 잠금되었습니다. ${params.remaining_minutes}분 후에 다시 시도해주세요.`,
  LOGIN_ATTEMPTS_REMAINING: (params) => `비밀번호가 일치하지 않습니다. 남은 시도 횟수: ${params.attempts_left}회`,
  PASSWORD_MISMATCH: '비밀번호가 일치하지 않습니다.',
  NOT_MATCHED: '일치하는 계정이 없습니다.',
  LOGIN_ERROR: '로그인 중 오류가 발생했습니다.',
  MULTI_LOGIN: '이미 다른 기기에서 로그인 중입니다.'
};

// 영어 메시지 (향후 확장을 위한 예시)
const enMessages = {
  ACCOUNT_LOCKED: (params) => `Your account is locked. Please try again after ${params.remaining_minutes} minutes.`,
  LOGIN_ATTEMPTS_REMAINING: (params) => `Incorrect password. Attempts remaining: ${params.attempts_left}`,
  PASSWORD_MISMATCH: 'Incorrect password.',
  NOT_MATCHED: 'Account not found.',
  LOGIN_ERROR: 'An error occurred during login.',
  MULTI_LOGIN: 'Already logged in from another device.'
};

// 환경 설정이나 사용자 설정에 따라 언어를 선택할 수 있도록 확장 가능
// 현재는 한국어를 기본값으로 사용
const messages = koMessages;

/**
 * 메시지 코드와 파라미터를 기반으로 적절한 메시지를 반환
 * @param {string} code - 메시지 코드
 * @param {Object} params - 메시지에 사용할 파라미터
 * @returns {string} - 번역된 메시지
 */
export const getMessage = (code, params = {}) => {
  // 메시지 함수가 있으면 실행, 아니면 메시지 문자열 반환
  if (typeof messages[code] === 'function') {
    return messages[code](params);
  }
  
  // 해당 코드의 메시지가 있으면 반환
  if (messages[code]) {
    return messages[code];
  }
  
  // 코드에 해당하는 메시지가 없으면 코드 자체를 반환
  return code;
};

export default getMessage;
